import { useEffect, useState } from "react";
import { Flex, Icon, Image, useColorModeValue } from "@chakra-ui/react";
import { MdLocalCafe } from "react-icons/md";

/**
 * A shop's photo, or a quiet branded panel when there isn't one. Google sometimes returns no
 * photo, or a photo name that no longer resolves, so the empty state covers both: no src, and an
 * image that fails to load. Layout props (w, h, position, inset…) apply to either.
 */
export default function ShopPhoto({ src, alt, iconSize = "28px", loading, ...layout }) {
  const [failed, setFailed] = useState(false);
  const bg = useColorModeValue(
    "linear(135deg, #efe4d3 0%, #e6d6bf 100%)",
    "linear(135deg, #2a1f17 0%, #1a130d 60%, #141110 100%)",
  );
  const iconColor = useColorModeValue("rgba(106,64,32,0.30)", "rgba(200,169,126,0.30)");

  useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    return (
      <Flex role="img" aria-label={alt} align="center" justify="center" bgGradient={bg} {...layout}>
        <Icon as={MdLocalCafe} boxSize={iconSize} color={iconColor} />
      </Flex>
    );
  }
  return <Image src={src} alt={alt} loading={loading} onError={() => setFailed(true)} {...layout} />;
}
